import { catchError, delay, from, interval, mergeMap, of, retry, switchMap, take, throwError } from 'rxjs';
export var VimeUtils;
(function (VimeUtils) {
  function setPlay(player, explicitState = null, allowRetry = false) {
    if (!player) {
      return new Promise((res, rej) => {
        if (allowRetry) {
          setTimeout(() => {
            setPlay(player, explicitState).then(res, rej);
          }, 500);
        }
      });
    } else {
      // vime does not like if play request is called repeatedly.
      // so we first need to check carefully if there actually is anything to do
      // or if vime is already playing / preparing for playback
      const newPlayingState = typeof explicitState === 'boolean' ? explicitState : !player.playing;
      const needsChange = newPlayingState !== player.playing;
      // console.log('setPlay - needs change?',needsChange,'newPlayingState=',newPlayingState)
      if (!needsChange) return;
      const promise = newPlayingState ? player.play() : player.pause();
      promise.then(_ => {
        // Automatic playback started!
      }).catch(error => {
        // Auto-play was prevented
        // by subscribing to the promise and catching errors, we prevent errors stating autoplay was blocked propagating to sentry & console
      });
      return promise;
    }
  }
  VimeUtils.setPlay = setPlay;
  function jump(player, direction, seconds = 10) {
    if (!player) return;
    const isFwd = direction === 'fwd';
    let newTime = player.currentTime + (isFwd ? seconds : -1 * seconds);
    if (newTime < 0) newTime = 0;
    if (newTime > player.duration) return;
    if (this.disallowSeekForward) {
      if (newTime > this.savedProgressSeconds) return false;
    }
    player.currentTime = newTime;
  }
  VimeUtils.jump = jump;
  function blockContextMenu(player) {
    if (!player) return;
    player.addEventListener('contextmenu', function (ev) {
      ev.preventDefault();
      console.log('context menu blocked!');
      return false;
    }, false);
  }
  VimeUtils.blockContextMenu = blockContextMenu;
  function autoplay(player) {
    if (!player) return;
    return player.canAutoplay().then(allowed => {
      // sometimes player will report allowed===true, but even then starting to play can throw a notAllowedError.
      if (allowed) {
        return VimeUtils.setPlay(player, true, false);
      } else {
        return false;
      }
    });
  }
  VimeUtils.autoplay = autoplay;
  function waitForValidVime(wrapper, loadingPromise) {
    let start$;
    if (loadingPromise) {
      start$ = from(loadingPromise).pipe(delay(10));
    } else {
      start$ = of(true);
    }
    return start$.pipe(take(1), switchMap(() => {
      return interval(100).pipe(mergeMap(() => {
        // console.log('loaded?', wrapper.nativePlayer?.nativeElement)
        if (wrapper.nativePlayer?.nativeElement) return of(wrapper.nativePlayer.nativeElement);
        return throwError(() => 'player not loaded yet');
      }), retry(10), take(1),
      // end interval if player is available!
      catchError(err => {
        return throwError(() => new Error('player failed to load: ' + err));
      }));
    }));
  }
  VimeUtils.waitForValidVime = waitForValidVime;
})(VimeUtils || (VimeUtils = {}));